// extracted by mini-css-extract-plugin
export default {"option":"_594c90db","logo":"_cd6175f3","details":"_fd26b9fa","importantDetails":"_8f41857c"};